import React, { useEffect, useState } from 'react'
import axios from 'axios'
import profile from '../../resources/images/default.png'
import { FaAlignLeft, FaSignOutAlt, FaUserAlt } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { useAuthContext } from '../../Hooks/useAuthContext'
import Sidebar from './Sidebar'
import Loader from '../../Component/Loader/Loader'
import './dashboard.css'

function Profile() {
  const { user, dispatch }                    = useAuthContext()
  const [data, setData]                       = useState(null)
  const [dashUser, setDashUser]               = useState(false)
  const [sidemenu, setSideMenu]               = useState(false)
  const [shouldMenuSlide, setShouldMenuSlide] = useState(false)
  const [loading, setLoading]                 = useState(true)

  useEffect(() => {
    const fetchUserData = async () => {
      setLoading(true)
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/user/get-user`,
          { headers: { Authorization: `Bearer ${user.token}`, 'Content-Type': 'application/json' } }
        )
        setData(response.data)
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false)
      }
    }
    fetchUserData()
  }, [user.token])

  const logout = () => dispatch({ type: 'LOGOUT', payload: null })

  const FIELDS = [
    { key: 'accountNumber', label: 'Account Number' },
    { key: 'firstname',     label: 'First Name' },
    { key: 'lastname',      label: 'Last Name' },
    { key: 'country',       label: 'Country' },
    { key: 'email',         label: 'Email' },
    { key: 'state',         label: 'State / Region' },
    { key: 'city',          label: 'City' },
    { key: 'zipcode',       label: 'Zip Code' },
    { key: 'address',       label: 'Address' },
    { key: 'occupation',    label: 'Occupation' },
    { key: 'verifyEmail',   label: 'Email Verified', render: v => v ? 'Yes' : 'No' },
  ]

  return (
    <div className="dashboard">

      {/* ── Header ──────────────────────────────────────── */}
      <div className="dashboard-header">
        <div className="rights-side">
          <Link to="/" style={{ textDecoration: 'none' }}>
            <p>{process.env.REACT_APP_APP_NAME}</p>
          </Link>
          <FaAlignLeft size={18} onClick={() => {
            setShouldMenuSlide(true)
            setSideMenu(!sidemenu)
          }} />
        </div>

        <div className="left-side">
          <div className="dh-avatar" onClick={() => setDashUser(!dashUser)}>
            <FaUserAlt size={14} />
          </div>
          {dashUser && (
            <div className="user-menu">
              <Link to="/user-profile"><p>Profile Overview</p></Link>
              <Link to="/profile-setting"><p>Profile Settings</p></Link>
              <p className="logout" onClick={logout}><FaSignOutAlt size={13} /> Logout</p>
            </div>
          )}
        </div>
      </div>

      {/* ── Body ─────────────────────────────────────────── */}
      {/*
        Sidebar MUST be here — a direct child of .dashboard,
        sibling to .dashboard-main-section — NOT inside the content div.
        This is what makes the mobile fixed drawer work correctly.
      */}
      {sidemenu && (
        <Sidebar
          shouldMenuSlide={shouldMenuSlide}
          onClose={() => setSideMenu(false)}
        />
      )}

      {/* pprofiledetails is full-width — sidebar overlays on top via fixed position */}
      {loading ? (
        <Loader />
      ) : (
        data && (
          <div className="pprofiledetails">
            <div className="ppdprofile">
              <img
                src={
                  data.profile
                    ? `${process.env.REACT_APP_IMG_BACKEND_URL}/images/${data.profile}`
                    : profile
                }
                alt="profile"
              />
            </div>
            <h4>Personal Details</h4>
            <div className="pddetails">
              {FIELDS.map(({ key, label, render }) => (
                <div className="ppdetail" key={key}>
                  <p>{label}</p>
                  <span>{render ? render(data[key]) : (data[key] ?? '—')}</span>
                </div>
              ))}
            </div>
          </div>
        )
      )}

    </div>
  )
}

export default Profile